<template>
  <v-switch
    inset
    :ripple="false"
    hide-details
    v-model="getDisponible"
    class="mx-2 pa-2 mt-1"
    :label="`${getDisponible ? 'Ver Todo' : 'Solo Diponible'}`"
    color="accent"
    :disabled="loadingSubCat"
    v-if="dataUser.IndAutenticado"
  ></v-switch>
</template>

<script>
import { mapState, mapMutations } from "vuex";
export default {
  computed: {
    ...mapState(["filter", "dataUser", "loadingSubCat"]),
    getDisponible: {
      get() {
        return this.filter.disponible;
      },
      set() {
        this.setDisponible();
      },
    },
  },
  methods: {
    ...mapMutations(["setDisponible"]),
  },
};
</script>

<style></style>
